import {BrowserRouter as Router, Route, Routes, Link} from 'react-router-dom';
import './App.css';
import NavBar from './components/NavBar';
import CategoryBlogs from './components/CategoryBlogs'
import Home from './components/Home';
import NotFoundPage from './components/NotFoundPage';
import Blog from './components/Blog';
import SignUp from './components/auth/SignUp';
import SignIn from './components/auth/SignIn';
import VerifyOtp from './components/auth/VerifyOtp';
import MyAccount from './components/MyAccount';
import Dashboard from './components/Dashboard';
import PublishBlog from './components/PublishBlog';
import Search from './components/Search';
import { io } from "socket.io-client";
import { useEffect, useState } from 'react';
import { useCookies } from 'react-cookie';


    
function App() {
  const [socket, setSocket] = useState(null);
  const [cookies, setCookies, removeCookie] = useCookies();


  useEffect(()=>{
    const socket = io.connect("https://blooggerr.onrender.com", {
      reconnect: true
    });
    setSocket(socket)
    console.log(socket)
    if(cookies['userId']){
      socket?.emit("addNewOnlineUser", (cookies['userId']))
      socket?.on("greet", (msg)=>console.log(msg))
      }
    },[])

  return (
    <div className="App">
      <Router>
      <main>
        <header className='header'>
        <NavBar socket={socket}/>
        </header>
        <section className='container'>
            <Routes>
              <Route path='/' element={<Home/>}/>
              <Route path='/blogs/:id' element={<Blog/>}/>
              <Route path='/publish' element={<PublishBlog/>}/>
              <Route path='/:category' element={<CategoryBlogs/>}/>
              <Route path='/account/:id' element={<MyAccount/>}/>
              <Route path='/dashboard' element={<Dashboard/>}/>
              <Route path='/register' element={<SignUp/>}/>
              <Route path='/login' element={<SignIn/>}/>
              <Route path='/search' element={<Search/>}/>
              <Route path='/verify-otp' element={<VerifyOtp/>}/>
              <Route path='*' element={<NotFoundPage/>}/>
            </Routes>
        </section>
      </main>
      </Router>
    </div>
  );
}

export default App;
